export const API_GET_ALL_USER = "/admin/usuarios/";
export const API_GET_SEARCH_USER = "/admin/usuarios/buscar/";
export const API_POST_SAVE_USER = "/admin/usuarios/registro-usuario";
export const API_PUT_UPDATE_USER = "/admin/usuarios/actualizar-usuario/";
export const API_GET_ALL_PROFILES = "/admin/usuarios/cargar-perfiles/"
export const API_PUT_UPDATE_PROFILE = "/admin/usuarios/actualizar-perfil-usuario/"